(function(){
  'use strict';
  function ready(fn){document.readyState==='loading'?document.addEventListener('DOMContentLoaded',fn):fn();}
  function youtubeApi(){
    if(window.YT&&typeof window.YT.Player==='function')return Promise.resolve(window.YT);
    if(window.__hpHomeYoutubeApi)return window.__hpHomeYoutubeApi;
    window.__hpHomeYoutubeApi=new Promise(function(resolve,reject){
      var finished=false;var previous=window.onYouTubeIframeAPIReady;
      window.onYouTubeIframeAPIReady=function(){
        if(typeof previous==='function')try{previous();}catch(error){}
        if(finished)return;finished=true;
        if(window.YT&&typeof window.YT.Player==='function')resolve(window.YT);else reject(new Error('YouTube player API unavailable'));
      };
      if(!document.querySelector('script[src="https://www.youtube.com/iframe_api"]')){
        var script=document.createElement('script');script.src='https://www.youtube.com/iframe_api';script.async=true;document.head.appendChild(script);
      }
      window.setTimeout(function(){if(!finished){finished=true;reject(new Error('YouTube player API timed out'));}},12000);
    });
    return window.__hpHomeYoutubeApi;
  }
  function videoUrl(id){return 'https://www.youtube-nocookie.com/embed/'+encodeURIComponent(id)+'?autoplay=1&mute=1&controls=0&loop=1&playlist='+encodeURIComponent(id)+'&playsinline=1&rel=0&modestbranding=1&disablekb=1&iv_load_policy=3&enablejsapi=1';}
  function setup(){
    var frame=document.querySelector('[data-hp-home-air-video]');var shell=document.querySelector('[data-hp-home-air-video-shell]');if(!frame||!shell)return;
    if(window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches){frame.remove();return;}
    var primary=frame.getAttribute('data-hp-youtube-primary');var backup=frame.getAttribute('data-hp-youtube-backup');var triedBackup=false;var started=false;
    function start(){
      if(started)return;started=true;frame.src=videoUrl(primary);
      youtubeApi().then(function(YT){
        new YT.Player(frame,{events:{
          onReady:function(event){try{event.target.mute();event.target.playVideo();}catch(error){}},
          onError:function(event){
            if(!triedBackup&&backup&&backup!==primary){triedBackup=true;shell.classList.add('is-backup');try{event.target.loadVideoById(backup);event.target.mute();event.target.playVideo();return;}catch(error){}}
            shell.classList.add('is-failed');
          },
          onStateChange:function(event){if(event.data===YT.PlayerState.ENDED)try{event.target.seekTo(0,true);event.target.playVideo();}catch(error){}}
        }});
      }).catch(function(){/* The regular muted iframe remains active when the optional player API is blocked. */});
    }
    function queueStart(){if('requestIdleCallback'in window)window.requestIdleCallback(start,{timeout:1800});else window.setTimeout(start,450);}
    if('IntersectionObserver'in window){
      var observer=new IntersectionObserver(function(entries){if(entries.some(function(entry){return entry.isIntersecting&&entry.intersectionRatio>=0.2;})){observer.disconnect();queueStart();}},{rootMargin:'0px',threshold:[0,0.2]});observer.observe(shell);
    }else queueStart();
  }
  function setupWheelVideos(){
    var frame=document.querySelector('[data-hp-wheel-brand-video]');var shell=document.querySelector('[data-hp-wheel-video-shell]');
    var visual=shell&&shell.closest('.hp-wheel-launch__visual');var links=visual?Array.prototype.slice.call(visual.querySelectorAll('[data-hp-wheel-video]')):[];
    if(!frame||!shell||!visual||!links.length)return;
    if(window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches){shell.remove();return;}
    var player=null;var playerReady=false;var playerStarting=false;var activeLink=null;var activeVideo='';var triedBackup=false;var directFallback=false;var hideTimer=0;
    function clearLinks(){links.forEach(function(link){link.classList.remove('is-video-active');});}
    function ensurePlayer(){
      if(playerStarting||playerReady)return;playerStarting=true;
      if(activeVideo)frame.src=videoUrl(activeVideo);
      youtubeApi().then(function(YT){
        player=new YT.Player(frame,{events:{
          onReady:function(event){playerReady=true;try{event.target.mute();event.target.pauseVideo();}catch(error){}if(activeLink)play(activeLink.getAttribute('data-hp-wheel-video'));},
          onError:function(){
            if(!activeLink)return;
            var backup=activeLink.getAttribute('data-hp-wheel-video-backup');
            if(!triedBackup&&backup&&backup!==activeVideo){triedBackup=true;play(backup);return;}
            shell.classList.remove('is-active');shell.classList.add('is-failed');clearLinks();
          },
          onStateChange:function(event){if(event.data===YT.PlayerState.ENDED&&activeLink)try{event.target.seekTo(0,true);event.target.playVideo();}catch(error){}}
        }});
      }).catch(function(){directFallback=true;if(activeLink)frame.src=videoUrl(activeLink.getAttribute('data-hp-wheel-video'));});
    }
    function play(id){
      if(!id)return;
      activeVideo=id;
      if(directFallback){frame.src=videoUrl(id);return;}
      if(!playerReady||!player){ensurePlayer();return;}
      try{player.loadVideoById(id);player.mute();player.playVideo();}catch(error){}
    }
    function activate(link){
      window.clearTimeout(hideTimer);if(!link)return;
      var id=link.getAttribute('data-hp-wheel-video');if(!id)return;
      activeLink=link;triedBackup=false;shell.classList.remove('is-failed');shell.classList.add('is-active');clearLinks();link.classList.add('is-video-active');
      if(id!==activeVideo||directFallback)play(id);else if(playerReady&&player)try{player.mute();player.playVideo();}catch(error){}
    }
    function deactivate(){
      if(visual.matches(':hover')||visual.contains(document.activeElement))return;
      activeLink=null;shell.classList.remove('is-active');clearLinks();
      if(directFallback){frame.src='about:blank';activeVideo='';return;}
      if(playerReady&&player)try{player.pauseVideo();}catch(error){}
    }
    function scheduleDeactivate(){window.clearTimeout(hideTimer);hideTimer=window.setTimeout(deactivate,120);}
    links.forEach(function(link){
      link.addEventListener('pointerenter',function(){activate(link);});
      link.addEventListener('focusin',function(){activate(link);});
      link.addEventListener('pointerdown',function(){activate(link);},{passive:true});
      link.addEventListener('focusout',scheduleDeactivate);
    });
    visual.addEventListener('pointerleave',scheduleDeactivate);
  }
  ready(function(){setup();setupWheelVideos();});
})();
